import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import '../../assets/stylesheets/Game3.scss';
import Game3Step1 from './Game3Step1';
import Game3Step2 from './Game3Step2';
import Game3Step3 from './Game3Step3';
import Game3Step4 from './Game3Step4';
import Game3Step5 from './Game3Step5';
import Game3Step6 from './Game3Step6';
import Game3Step7 from './Game3Step7';
import Guidelines from './Guidelines';
import Modal from 'react-modal';

@inject('AuthStore', 'SchoolStore', 'Game3Store','Navigator')
@observer
export default class Game3 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            step: 1,
            navButtonLabels: [
                "Number of Teams",
                "Students’ Levels",
                "Show guidelines",
                "Start Game",
                "Next Step",
                "Final Score",
                "Continue Lesson"
            ],
            gameSteps: [
                <Game3Step1/>,
                <Game3Step2/>,
                <Game3Step3/>,
                <Game3Step4/>,
                <Game3Step5/>,
                <Game3Step6/>,
                <Game3Step7/>
            ],
            numberOfGuideLines: 1
        };

        // Prevent unnecessary render
        this.teamAnswer = null;
    }

    componentDidMount() {
        this.props.Game3Store.loadQuestions();
    }

    handleNextStep() {

        if (this.teamAnswer) {
            this.teamAnswer = null;
        }

        if ( this.state.step === 4 ) {
            let num = this.state.numberOfGuideLines + 1;
            this.setState({numberOfGuideLines: num});

            if ( this.state.numberOfGuideLines < this.props.Game3Store.players.length) {
                this.props.Game3Store.round += 1;
                return;
            }
        }

        if (this.state.step === 7) {
            this.props.Game3Store.minutes = 10;
            this.props.Game3Store.seconds = 1;
            this.props.Game3Store.modalIsOpen = false;
            this.props.Navigator.push("/games");
            return;
        }

        this.setState(
            prevState => {
                return {
                    step: prevState.step + 1
                }
            }
        )
    }

    handleShowGuidelines() {
        this.props.Game3Store.showGuidelines = true;
        this.setState({numberOfGuideLines: 1});
    }

    handleChangeAnswer({player, index}) {
        this.teamAnswer = {player, index};
    }

    handleClose() {
        this.props.Game3Store.minutes = 10;
        this.props.Game3Store.seconds = 1;
        this.props.Game3Store.modalIsOpen = false;
        this.props.Navigator.push("/games")
    }

    openModal() {
        this.props.Game3Store.modalIsOpen = true;
    }

    closeModal() {
        this.props.Game3Store.modalIsOpen = false;
    }

    render() {

        const {
            step,
            gameSteps,
            navButtonLabels,
        } = this.state;

        const {
            players
        } = this.props.Game3Store;

        let cantGoNextStep = false;
        if (step === 3) {
            cantGoNextStep = players.find(p => p.levels.length === 0);
        }

        if( step === 5 ) {
            cantGoNextStep = true;
        }

        if (step === 6) {
            const btnNavNext = document.querySelector(".btn-nav-next");
            btnNavNext.className = "btn-nav-next disabled";
            cantGoNextStep = true;
        }

        const customStyles = {
            overlay : {
                position          : 'fixed',
                top               : 0,
                left              : 0,
                right             : 0,
                bottom            : 0,
                backgroundColor   : 'black'
            },
            content : {
                top                   : '50%',
                left                  : '50%',
                right                 : 'auto',
                bottom                : 'auto',
                marginRight           : '-50%',
                transform             : 'translate(-50%, -50%)',
                background            : 'black',
                color                 : 'white'
            }
        };

        var nextTeam = this.state.step === 4 ? true : false;

        var labelButton = navButtonLabels[step - 1];

        if ( nextTeam ) {
            if ( this.state.numberOfGuideLines < this.props.Game3Store.players.length) {
                labelButton = 'Next Team';
            }
        }

        if( this.props.Game3Store.showGuidelines ) {
            return <Guidelines/>;
        } else {
            return (
                <div className="Game3 Page">
                    <Modal
                        isOpen={this.props.Game3Store.modalIsOpen}
                        style={customStyles}
                        contentLabel="Modal"
                    >
                        <h1>Would you like to leave the game?</h1>
                        <button className="btn-modal"
                                onClick={this.handleClose.bind(this)}>YES
                        </button>
                        <button className="btn-modal right"
                                onClick={this.closeModal.bind(this)}>NO
                        </button>
                    </Modal>
                    <div className="Close">
                        <button className="btn-close"
                                onClick={this.openModal.bind(this)}>X
                        </button>
                    </div>
                    {   step === 5 ? <Game3Step5 onShowGuidelines={this.handleShowGuidelines.bind(this)}/> :
                        step === 4 ? <Game3Step4 onChangeAnswer={this.handleChangeAnswer.bind(this)}/> :
                        gameSteps[step - 1]
                    }
                    <div className="nav">
                        <button
                            className={"btn-nav-next" + ((step === 3 && players.length === 0) || cantGoNextStep ?  " disabled": "")}
                            onClick={this.handleNextStep.bind(this)}>{labelButton}</button>
                    </div>
                </div>
            );
        }


    }
}


// WEBPACK FOOTER //
// ./src/containers/Game3/Game3.js